import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CEUMA_URL_API } from 'app/config';
import { CidadesService } from 'app/shared/cidades/cidades.service';
import { addAuthenticationUrl } from 'app/shared/interceptors/auth.interceptor';

import { Pessoa } from 'models/pessoa';
import { environment } from 'environments/environment';

export const PESSOA_API_URL = CEUMA_URL_API + '/pessoa/buscarPessoaFisica';
export const ATUALIZA_DADOS_API_URL = `${CEUMA_URL_API}/atualizaDadosPessoais/`;
export const ATUALIZA_SENHA_API_URL = `${CEUMA_URL_API}/alterarSenha/`;
export const RECUPERA_CPD_URL = `${CEUMA_URL_API}/recuperaAlunoReingresso`;
import { AuthenticationService } from 'app/core/authentication/authentication.service';
const API_PESSOA_SAVE = `${CEUMA_URL_API}/pessoa/pessoaFisica`;

@Injectable()
export class PessoaService {

  private headers: HttpHeaders = new HttpHeaders({
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization':this.authenticationService.getAcessToken()
  });

  constructor(
    private http: HttpClient,
    private cidadesService: CidadesService,
    private authenticationService: AuthenticationService
  ) {
    addAuthenticationUrl(ATUALIZA_DADOS_API_URL);
    addAuthenticationUrl(ATUALIZA_SENHA_API_URL);
  }

  public buscarPessoa(cpf: string, ano: string = '0' , codigo:string = '0'): Promise<Pessoa> {
    if (cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
    }
    const url = `${PESSOA_API_URL}/${cpf}/${ano}/${codigo}`;
    return new Promise<Pessoa>((resolve, reject) => {
      this.http.get(url).subscribe(async (output: any) => {
        if (!output || !Array.isArray(output) || output.length === 0) {
          resolve(null);
        } else {
          const pessoa: Pessoa = await this.buildPessoaCpf(output);
          resolve(pessoa);
        }
      });
    });
  }

  public buscarPessoaPeloCpd(cpd: string): Promise<Pessoa> {
    if (cpd) {
      cpd = cpd.replace(/[^\d]+/g, '');
    }

    const url = `${RECUPERA_CPD_URL}/${cpd}`;
    return new Promise<Pessoa>((resolve, reject) => {
      this.http.get(url).subscribe((output: any) => {

        if (!output || !output.cpd || output.mensagem) {
          if (output && output.mensagem) {
            const pos = output.mensagem.indexOf('.');
            output.mensagem = pos !== -1 ? output.mensagem.substr(0, pos + 1) : output.mensagem;
          }
          reject({ error: output });

        } else {
          const pessoa: Pessoa = this.buildPessoaCpd(output);
          resolve(pessoa);
        }
      });
    });
  }

 public  savePessoa(data): Observable<any> {
    return this.http.post(`${API_PESSOA_SAVE}`, data,  { headers: this.headers });
  }

  public atualizar(pessoa: Pessoa): Observable<any> {
    const nascimento = pessoa.dtNascimento.split('/');
    const parsePattern = {
      codigo: pessoa.codigo,
      pessoa: {
        codigo: pessoa.codigo,
        nome: pessoa.nome,
        email: pessoa.email,
        ddd: pessoa.ddd,
        celular: pessoa.celular,
        cidade: {
          id: pessoa.cidade.id,
          nome: pessoa.cidade.nome,
          uf: pessoa.uf,
        },
      },
      cpf: pessoa.cpf,
      dataNascimento: `${nascimento[2]}-${nascimento[1]}-${nascimento[0]}`,
      rg: pessoa.rg,
      orgexp: pessoa.orgexp,
    };

    return this.http.post(ATUALIZA_DADOS_API_URL, parsePattern, { headers: this.headers });
  }

  public alterarSenha(codigo: number, senhaAtual: string, senhaAntiga: string, tipo:string, sigla:string): Observable<any> {
    if(tipo==='GLOBAL'||tipo==null){
      const data = {
        pessoaFisica: {
          codigo,
          pessoa: { codigo },
        },
        senhaAtual,
        senhaAntiga,
      };
      return this.http.post(ATUALIZA_SENHA_API_URL, data, {
        headers: this.headers,
      });
    }else{
      const data = {
        tipoAltSenha: tipo,
        contexto: environment.loginContexto,
        senhaAntiga: senhaAntiga,
        novaSenha: senhaAtual,
        siglaSistema:sigla
      }
      return this.http.post('https://www.extranet.ceuma.br/authentication-api/alterarSenha', data, {
        headers: this.headers,
      });
    }

  }

  public validarCpf(cpf: string): boolean {

    if (!cpf) {
      return false;
    }

    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf === '') {
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111'
      || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444'
      || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777'
      || cpf === '88888888888' || cpf === '99999999999') {
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++) {
      add += parseInt(cpf.charAt(i), 10) * (10 - i);
    }

    let rev = 11 - (add % 11);
    if (rev === 10 || rev === 11) {
      rev = 0;
    }

    if (rev !== parseInt(cpf.charAt(9), 10)) {
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i), 10) * (11 - i);
    }
    rev = 11 - (add % 11);

    if (rev === 10 || rev === 11) {
      rev = 0;
    }

    if (rev !== parseInt(cpf.charAt(10), 10)) {
      return false;
    }

    return true;
  }

  public validarCpd(cpd: string): boolean {
    if (!cpd) {
      return false;
    }

    cpd = cpd.replace(/[^\d]+/g, '');
    if (cpd === '') {
      return false;
    }

    if (cpd.length < 1 || cpd.length > 8) {
      return false;
    }

    return true;
  }

  private convertDtFromTimestampToBr(timestamp: string) {
    //console.log(timestamp);
    if (!timestamp) {
      return null;
    }
    /*
    const date = new Date(timestamp);
    if (!date) {
      return null;
    }
    */
    console.log(timestamp);
    const bits = timestamp.split(' ')[0].split('-');
    return `${bits[2]}/${bits[1]}/${bits[0]}`;
  }

  private convertDtFromIsoToBr(dateIso: string) {
    if (!dateIso) {
      return null;
    }

    const bits = dateIso.split(' ')[0].split('-');
    return `${bits[0]}/${bits[1]}/${bits[2]}`;
  }

  private async buildPessoaCpf(apiOutput: any): Promise<Pessoa> {
    const pessoa = new Pessoa();
    pessoa.cpf = apiOutput[0].cpf;
    pessoa.codigo = apiOutput[0].pessoa && apiOutput[0].pessoa.codigo;
    pessoa.nome = apiOutput[0].pessoa && apiOutput[0].pessoa.nome;
    pessoa.email = apiOutput[0].pessoa && apiOutput[0].pessoa.email;
    pessoa.dtNascimento = this.convertDtFromTimestampToBr(apiOutput[0].dataNascimento);
    pessoa.ddd = apiOutput[0].pessoa && apiOutput[0].pessoa.ddd;
    pessoa.celular = apiOutput[0].pessoa && apiOutput[0].pessoa.celular;
    pessoa.rg = apiOutput[0].rg;
    pessoa.orgexp = apiOutput[0].orgexp;
    pessoa.vinculo =  apiOutput[0].vinculo;
    pessoa.isInscrito = apiOutput[0].isInscrito;

    // resolvendo uf e cidade
    if (apiOutput[0].pessoa && apiOutput[0].pessoa.cidade) {
      const uf = await this.cidadesService.getEstadoBySigla(apiOutput[0].pessoa && apiOutput[0].pessoa.cidade.uf.sigla);
      const cidade = await this.cidadesService.getCidadeById(apiOutput[0].pessoa && apiOutput[0].pessoa.cidade.id);
      pessoa.uf = uf;
      pessoa.cidade = cidade;
    }

    return pessoa;
  }


  private buildPessoaCpd(apiOutput: any): Pessoa {
    const pessoa = new Pessoa();

    pessoa.cpd = apiOutput.cpd;
    pessoa.cpf = apiOutput.cpf;
    pessoa.nome = apiOutput.nome;
    pessoa.email = apiOutput.email ? apiOutput.email.trim() : '';
    pessoa.dtNascimento = this.convertDtFromIsoToBr(apiOutput.dataNascimento);
    pessoa.celular = apiOutput.celular ? apiOutput.celular.trim() : '';
    // esse dado nao vem
    pessoa.ddd = '';

    pessoa.dadosCpd = {
      turno: apiOutput.turno,
      campus: apiOutput.codigo.substring(0, 2),
      curso: apiOutput.codigo.substring(2),
      anoSemestreRef: apiOutput.anoReferencia + '',
      apoio: apiOutput.apoio,
    };

    // manipulacoes necessárias
    if (pessoa.dadosCpd.anoSemestreRef) {
      const ano = pessoa.dadosCpd.anoSemestreRef.substring(0, 4);
      const semestre = pessoa.dadosCpd.anoSemestreRef.substring(4);
      if (semestre && semestre !== '0') {
        pessoa.dadosCpd.anoSemestreRef = `${ano}.${semestre}`;
      } else {
        pessoa.dadosCpd.anoSemestreRef = `${ano}`;
      }
    }

    return pessoa;
  }
}
